var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10C19 11.4008 18.5886 12.7054 17.8799 13.7998C17.9587 14.1876 18 14.589 18 15C18 18.3137 15.3137 21 12 21C8.68629 21 6 18.3137 6 15C6 14.589 6.04133 14.1876 6.12007 13.7998C5.41144 12.7054 5 11.4008 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10ZM6 10.5C6 12.1235 7.1054 13.4888 8.60462 13.8844C8.22143 14.4981 8 15.2232 8 16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16C16 15.2232 15.7786 14.4981 15.3954 13.8844C16.8946 13.4888 18 12.1235 18 10.5C18 8.567 16.433 7 14.5 7C13.5207 7 12.6353 7.40224 12 8.05051C11.3647 7.40224 10.4793 7 9.5 7C7.567 7 6 8.567 6 10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5259 13.9541C20.148 12.772 20.5 11.4255 20.5 9.99997C20.5 9.42177 20.4423 8.85706 20.3323 8.31128C21.3207 8.80197 22 9.82163 22 11C22 12.4774 20.932 13.7054 19.5259 13.9541Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47409 13.9541C3.068 13.7054 2 12.4774 2 11C2 9.82163 2.67935 8.80197 3.66774 8.31128C3.55773 8.85706 3.5 9.42177 3.5 9.99997C3.5 11.4255 3.852 12.772 4.47409 13.9541Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.5C11.5 15.7761 11.0523 16 10.5 16C9.94772 16 9.5 15.7761 9.5 15.5C9.5 15.2239 9.94772 15 10.5 15C11.0523 15 11.5 15.2239 11.5 15.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.5C14.5 15.7761 14.0523 16 13.5 16C12.9477 16 12.5 15.7761 12.5 15.5C12.5 15.2239 12.9477 15 13.5 15C14.0523 15 14.5 15.2239 14.5 15.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C15.3284 12 16 11.3284 16 10.5C16 9.67157 15.3284 9 14.5 9C14.3463 9 14.1979 9.02313 14.0583 9.06609C14.3187 9.18368 14.5 9.44567 14.5 9.75C14.5 10.1642 14.1642 10.5 13.75 10.5C13.4457 10.5 13.1837 10.3187 13.0661 10.0583C13.0231 10.1979 13 10.3463 13 10.5C13 11.3284 13.6716 12 14.5 12Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C10.3284 12 11 11.3284 11 10.5C11 9.67157 10.3284 9 9.5 9C9.34627 9 9.19794 9.02313 9.05829 9.06609C9.31874 9.18368 9.5 9.44567 9.5 9.75C9.5 10.1642 9.16421 10.5 8.75 10.5C8.44567 10.5 8.18368 10.3187 8.06609 10.0583C8.02313 10.1979 8 10.3463 8 10.5C8 11.3284 8.67157 12 9.5 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonkey);
export default __webpack_public_path__ + "static/media/monkey.865cccf25e415fcc931001e0ab81ed7c.svg";
export { ForwardRef as ReactComponent };